import { FC, useContext, useEffect, useState } from "react";
import { animateScroll as scroll } from "react-scroll";

import ExplainPopover from "../Popover/ExplainPopover";
import AdminHeader from "../SubComponents/AdminHeader";
import Header from "../SubComponents/Header";
import NotAuthBanner from "../SubComponents/Projects/NotAuthBanner";
import PoolsContainer from "./PoolsContainer";
import Footer from "../SubComponents/Footer";
import PoolContext from "../../store/Pool/PoolContext";
import AuthContext from "../../store/Auth/AuthContext";

const ProjectPools: FC = () => {

    const { isAuth } = useContext<any>(AuthContext);
    const { unsetActivePool } = useContext<any>(PoolContext);

    // Local states
    const [firstTime, setFirstTime] = useState(false);
    const [popover, setPopover] = useState("live");
    const [liveProjectsAnchor, setLiveProjectsAnchor] = useState<any>(null);
    const [singleProjectAnchor, setSingleProjectAnchor] = useState<any>(null);
    const [projectStatusAnchor, setProjectStatusAnchor] = useState<any>(null);
    const [closedPoolAnchor, setClosedPoolAnchor] = useState<any>(null);
    const [tutorialsAnchor, setTutorialsAnchor] = useState<any>(null);
    const [position, setPosition] = useState<any>(null);
    const [openLoginModal, setOpenLoginModal] = useState<boolean>(false);

    useEffect(() => {
        unsetActivePool();
        scroll.scrollToTop();
        if (isAuth) {
            if (!localStorage.getItem("previouslyVisited")) {
                localStorage.setItem("previouslyVisited", "true");
                setFirstTime(true);
            }
        }
    }, []);

    useEffect(() => {
        if (position) {
          position.scrollIntoView();
          setPosition(null);
        }
      }, [position]);

    const handlePopoverNext = (anchor: any, popover: string) => {
        anchor.scrollIntoView();
        setPopover(popover);
      };
    

    const handleFinish = () => {
        setFirstTime(false);
        setPopover("");
        scroll.scrollToTop();
    };

    return (
        <>
            {
                isAuth
                ?
                    (
                        <AdminHeader
                            popoverRef={(e: any) => setLiveProjectsAnchor(e.current)}
                            restartTooltip={() => {
                                // popoverRef has to be defined but with tabs
                                setFirstTime(true);
                                setPopover("live")
                            }}
                            tutorialPop={(e: any) => setTutorialsAnchor(e.current)}
                        />
                    )
                :   
                    (
                        <Header timer={false} authPage />
                    )
                    
            }
            {
                !openLoginModal && !isAuth && <NotAuthBanner />
            }
            
            <ExplainPopover
                id="simple-popover"
                open={firstTime && popover === "live"}
                text={
                    <>
                      <ul>
                        <li>- Live deals</li>
                        <li>- Upcoming opportunities</li>
                        <li>- Past deals</li>
                      </ul>
                    </>
                  }
                anchorEl={liveProjectsAnchor}
                title="Deals Overview"
                next={() => setPopover("project")}
                skip={handleFinish}
                handleClose={handleFinish}
            />
            <ExplainPopover
                id="simple-popover"
                open={popover === "project"}
                text={`Each card is a project. You can click on a card for further details.`}
                anchorEl={singleProjectAnchor}
                title="Project on GainsPad"
                next={() => setPopover("status")}
                skip={handleFinish}
                handleClose={handleFinish}
            />
            <ExplainPopover
                id="simple-popover"
                open={popover === "status"}
                text={
                    <ul>
                      <li>- Launching Soon: Access opens soon.</li>
          
                      <li>- Get Whitelisted: Pass the quiz.</li>
          
                      <li>- Contribute: Start investing.</li>
          
                      <li>- Failed: Not whitelisted. Try another project.</li>
                    </ul>
                  }
                anchorEl={projectStatusAnchor}
                title="Project Status"
                next={() => setPopover("closed")}
                skip={handleFinish}
                handleClose={handleFinish}
            />
            <ExplainPopover
                id="simple-popover"
                open={popover === "closed"}
                text={`This section shows the past project on the GainsPad and their performance`}
                anchorEl={closedPoolAnchor}
                title="Funded Projects"
                next={() => setPopover("tutorials")}
                skip={handleFinish}
                handleClose={handleFinish}
            />
            <ExplainPopover
                id="simple-popover"
                open={popover === "tutorials"}
                text={`Refer to these tutorials for step-by-step instructions on how to participate in GainsPad or reach out to us on telegram for support.`}
                anchorEl={tutorialsAnchor}
                title="Find Support"
                skip={handleFinish}
                handleClose={handleFinish}
            />
            <PoolsContainer 
                setOpenLoginModal={setOpenLoginModal} 
                livePop={(e: any) => setLiveProjectsAnchor(e.current)}
                singleProjectPop={(e: any) => setSingleProjectAnchor(e.current)}
                statusPop={(e: any) => setProjectStatusAnchor(e.current)}
                closedPop={(e: any) => setClosedPoolAnchor(e.current)}
            />
            <Footer />
        </>
    )
}

export default ProjectPools;